import React, { useState, Fragment } from 'react';
import Loader from '4all-ui/components/Loader';
import Tag from '4all-ui/components/Tag';
import { styles } from '4all-ui/styles';
import * as style from './style';
import GenericListHeader from '../GenericListHeader';
import { filterOptions } from '../../helpers/search';
import { normalizeTags } from '../../helpers/products';
import * as GenericStyles from '../../styles/StyledComponents/GenericList';
import { MAX_SELECTED_TAGS } from '../../helpers/constants';

const getStyle = (isSelected, isFull) => {
  const defaultStyle = {
    cursor: 'pointer',
    marginBottom: '15px',
    padding: '3px 15px',
    wordBreak: 'break-all',
    fontSize: styles.fontSizes.SIZE_7,
  };
  if (isSelected) {
    return {
      ...defaultStyle,
      border: `1px solid ${styles.colors.MAIN_COLOR}`,
    };
  }
  if (isFull) {
    return {
      ...defaultStyle,
      border: `1px solid ${styles.colors.GRAY_LIGHT_2} !important`,
    };
  }
  return defaultStyle;
};

const isSelected = (id, selectedTags) => selectedTags.some(tag => tag === id);

const isFull = selectedTags => selectedTags.length === MAX_SELECTED_TAGS;

const renderTags = ({ filteredTags, error, selectedTags, isLoading, onToggle }) => {
  if (error && error.message) {
    return <style.ErrorMessage>{error.message}</style.ErrorMessage>;
  }
  if (isLoading) {
    return (
      <GenericStyles.LoaderContainer customStyles={{ marginTop: '90px' }}>
        <Loader size="60px" />
      </GenericStyles.LoaderContainer>
    );
  }
  return (
    <Fragment>
      {filteredTags.map(tag => (
        <Tag
          className={isSelected(tag.id, selectedTags) ? 'active' : ''}
          key={tag.id}
          tag={{
            value: tag.id,
            label: tag.title,
          }}
          secondary={!isSelected(tag.id, selectedTags)}
          disabled={!isSelected(tag.id, selectedTags) && isFull(selectedTags)}
          customStyles={getStyle(isSelected(tag.id, selectedTags), isFull(selectedTags))}
          onClick={() => onToggle(tag.id)}
        >
          {tag.title}
        </Tag>
      ))}

      {filteredTags.length === 0 && (
        <style.StyledEmptyMessage big>Nenhuma tag encontrada</style.StyledEmptyMessage>
      )}
    </Fragment>
  );
};

const SelectTagList = ({ tags, selectedTags, onToggle, error }) => {
  const { list, isLoading } = tags;
  const [searchText, setSearchText] = useState('');
  const filteredTags = filterOptions(searchText, normalizeTags(list), 'title');

  return (
    <style.TagsContainer>
      <GenericListHeader
        id="tag-search"
        title="Tags"
        desc="Selecione as tags que condizem com o seu produto."
        search
        onChange={e => setSearchText(e.target.value)}
        searchText={searchText}
        searchPlaceholder="Pesquisar Tag"
        searchInputSize="100%"
      />
      <style.Tags>
        {renderTags({ filteredTags, error, selectedTags, isFull, isLoading, onToggle })}
      </style.Tags>
    </style.TagsContainer>
  );
};

export default SelectTagList;



// WEBPACK FOOTER //
// ./src/components/SelectTagList/index.js